import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import envelope from 'assets/img/icons/spot-illustrations/16.png';

const ContentSuccess = ({ titleTag: TitleTag, title, sub, content }) => {
  return (
      <div className="text-center">
          <img
            className="d-block mx-auto mb-4"
            src={envelope}
            alt="sent"
            width={100}
            />
        <TitleTag>{title}</TitleTag>
        <p>
          {sub}
          <br className="d-none d-sm-block" />
          {content}
        </p>
        <Button
          as={Link}
          color="primary"
          size="sm"
          className="mt-3"
          to={`/authentication/login`}
        >
          <FontAwesomeIcon
            icon="chevron-left"
            transform="shrink-4 down-1"
            className="me-1"
          />
          Return to Login
        </Button>
      </div>
  );
};

export default ContentSuccess;
